import React from "react";
import usePageview from "core/hooks/usePageview";
import useScrollToTop from "core/hooks/useScrollToTop";
import { useTranslation } from "react-i18next";
import { useSearchParams, useLocation } from "react-router-dom";
import ArenaPosts from "arena/components/ArenaPosts";
import ArenaHelmet from "arena/components/ArenaHelmet";

export default function Posts() {
  const { t } = useTranslation("arena");
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const tagIds = searchParams.getAll("tagId");
  const rightholderIds = searchParams.getAll("rightholderId");

  usePageview(location.pathname, "Posts");
  useScrollToTop();

  return (
    <>
      <ArenaHelmet title={t("posts")} />

      <ArenaPosts
        title={t("posts")}
        view="GRID"
        tagIds={tagIds}
        rightholderIds={rightholderIds}
        loadMore
      />
    </>
  );
}
